/* ==========================================================================
   折扣码「折后价」展示 —— 运营清单行 21（稿 55:16015「限时优惠情况」）
   ==========================================================================
   规则（运营口径）：商品配了折扣码且当前变体适用时，价格显示「原价减折扣」。
     · 情况 A 折扣是数字（metafield 首段写「Save $230 Today」）→ 原价 − 230
     · 情况 B 折扣是百分比（写「Save 20% Today」）        → 原价 × (1 − 20%)
     · 价格区间商品（$549.99-$1,199.99）两端各自计算
     · 解析不出金额/比例、没配折扣码或当前变体不适用 → 恢复主题原价

   🚨 只做展示，不改购物车价格。加购、结账、订单金额仍走 Shopify 原价，
      折扣在结账时由折扣码真正生效。所以券条文案里必须让顾客知道要用码
      （默认文案「Save $230 with our auto-applied code.」已经说了 auto-applied，
      若店铺没配自动应用，运营要把这句改成「用码 XXX」）。

   为什么用 JS 而不是 Liquid：
     变体切换后价格是主题的 JS 重写 [data-price] 的文本，服务端算好的值会被覆盖；
     而且吸底条 / quick view 抽屉是同一份 product-price snippet 的另一处实例。
     所以这里统一在展示层收口：算一次、三处同步、变体切换后自动重算。

   作用范围（显式列举，不用宽泛选择器）：
     · PDP 主价格   .product__primary-right .product__price / .product__price-block .product__price
     · 吸底加购条   .sticky-atc-bar__price
     · quick view   [data-amada-drawer="amada-quickview"] .amada-qv__price
   捆绑区 / PERFECT PAIRINGS 卡片用的是别的类名，不在范围内 —— 那些是**别的商品**，
   套本商品的折扣是错的。
   ========================================================================== */
(function () {
  'use strict';
  /* 2026-10-06：只执行一次。快速预览资源改为全站加载（购物车抽屉推荐「+」开快速预览），
     PDP / 分类页自己也会挂同一个文件 → 同一页出现两个 <script src>，第二份直接让位，
     否则事件委托会绑两遍（点一次触发两次）。 */
  if (window.__amadaDiscountPriceLoaded) return;
  window.__amadaDiscountPriceLoaded = true;

  var CLS = 'amada-price--coupon';
  // 只观察会改变优惠计算结果的配置属性。不要把脚本自己写入的 hidden、
  // data-amada-orig-price / shown / filled 放进来，否则每次 paint/restore 都会再唤醒自己。
  var RULE_ATTRIBUTES = [
    'data-amada-discount-code',
    'data-amada-discount-pct',
    'data-amada-discount-amount',
    'data-amada-discount-eligible-variants',
    'data-amada-discount-initial-variant',
  ];
  var writing = false;
  var variantRefreshPending = { pdp: false, qv: false };

  function toNumber(s) {
    var n = parseFloat(String(s == null ? '' : s).replace(/,/g, ''));
    return isFinite(n) ? n : NaN;
  }

  /** 券条上挂的折扣规则；没券条 / 没折扣码 / 解析不出 → null（调用方据此什么都不做） */
  function readRule(couponEl) {
    if (!couponEl) return null;
    if (!couponEl.getAttribute('data-amada-discount-code')) return null;
    var pct = toNumber(couponEl.getAttribute('data-amada-discount-pct'));
    if (isFinite(pct) && pct > 0 && pct < 100) return { type: 'pct', v: pct };
    var amt = toNumber(couponEl.getAttribute('data-amada-discount-amount'));
    if (isFinite(amt) && amt > 0) return { type: 'amt', v: amt };
    return null;
  }

  function variantIsEligible(couponEl, variantId) {
    if (!couponEl) return false;
    var eligible = couponEl.getAttribute('data-amada-discount-eligible-variants');
    // 没传 product 的旧调用点保持商品级券行为；传了就必须命中真实 variant ID。
    if (eligible == null) return true;
    var id = String(variantId == null
      ? (couponEl.getAttribute('data-amada-discount-initial-variant') || '')
      : variantId).trim();
    return !!id && eligible.indexOf('|' + id + '|') > -1;
  }

  function currentVariantId(couponEl) {
    if (!couponEl) return '';
    var scope = couponEl.classList && couponEl.classList.contains('amada-coupon--qv') ? 'qv' : 'pdp';
    var root;
    var input;
    if (scope === 'qv') {
      // 券条在 drawer body 的 [data-amada-qv-root] 内，真实 variant input 在 sibling footer。
      // 必须以整个 drawer 为作用域；只在 body root 内找会永远取不到输入，错误回退初始 variant。
      root = couponEl.closest ? couponEl.closest('[data-amada-drawer="amada-quickview"]') : null;
      input = root && root.querySelector('[data-amada-qv-variant-id]');
    } else {
      root = couponEl.closest ? couponEl.closest('.product') : null;
      input = root && root.querySelector('[data-product-form] [data-variant-select]');
    }
    // 输入存在但值为空代表当前组合无可用 variant，不能回退 initial 误用上一件的券。
    return input
      ? String(input.value || '')
      : String(couponEl.getAttribute('data-amada-discount-initial-variant') || '');
  }

  /** 按样本的小数位/千分位格式化，保证「$1,199.99」减完还是「$1,169.99」而不是「1169.99」 */
  function formatLike(sample, value) {
    var dot = sample.indexOf('.');
    var dec = dot > -1 ? sample.length - dot - 1 : (value % 1 === 0 ? 0 : 2);
    var s = value.toFixed(dec);
    if (sample.indexOf(',') > -1 || value >= 1000) {
      var p = s.split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      s = p.join('.');
    }
    return s;
  }

  /** 把一段价格文本里的每个数字都换成折后数字（区间价两端各算各的） */
  function discountText(text, rule) {
    return text.replace(/\d[\d,]*(?:\.\d+)?/g, function (m) {
      var v = toNumber(m);
      if (!isFinite(v)) return m;
      var d = rule.type === 'pct' ? v * (1 - rule.v / 100) : v - rule.v;
      if (d < 0) d = 0;
      return formatLike(m, d);
    });
  }

  function nowEl(box) {
    return box.querySelector('[data-price], [data-amada-qv-price]');
  }
  function compareEl(box) {
    return box.querySelector('[data-compare-price], [data-amada-qv-compare]');
  }

  /**
   * 给一个价格容器套折后价。
   * 划线原价的口径：
   *   · 商品自己就有 compare_at_price（主题已经渲染出划线价）→ **保留主题的**，不覆盖。
   *     否则会出现「MSRP / 售价 / 折后价」三个数字，稿上只有两个。
   *   · 没有 compare_at_price → 把折前售价填进划线槽（稿 55:16073 的位置），
   *     并打上 data-amada-filled，下次重算时认得出这是我们填的、可以刷新。
   */
  function paint(box, rule, refreshRequested, variantId) {
    var now = nowEl(box);
    if (!now) return;

    var orig = now.getAttribute('data-amada-orig-price');
    var current = now.textContent.trim();
    if (!current) return;
    var previousVariantId = now.getAttribute('data-amada-price-variant');
    // 同一 variant 的重复事件并不证明价格 DOM 被主题重写，不能把现有折后价当作新原价再减一次。
    var forceFresh = !!(
      refreshRequested && variantId && previousVariantId && String(variantId) !== previousVariantId
    );

    // 主题刚重写过价格（变体切换）→ 以页面上的新值为准，重新记一次折前价
    if (forceFresh || orig == null || now.getAttribute('data-amada-shown') !== current) {
      orig = current;
      now.setAttribute('data-amada-orig-price', orig);
    }
    if (!/\d/.test(orig)) return;
    if (variantId && previousVariantId !== String(variantId)) {
      now.setAttribute('data-amada-price-variant', String(variantId));
    }

    var next = discountText(orig, rule);
    writing = true;
    try {
      if (now.textContent !== next) now.textContent = next;
      if (now.getAttribute('data-amada-shown') !== next) now.setAttribute('data-amada-shown', next);

      var cmp = compareEl(box);
      if (cmp) {
        var mine = cmp.hasAttribute('data-amada-filled');
        if (!cmp.textContent.trim() || mine) {
          if (cmp.textContent !== orig) cmp.textContent = orig;
          cmp.setAttribute('data-amada-filled', '');
          cmp.hidden = false;
        }
      } else {
        // quick view 在没有 compare_at 时压根不渲染 <s> → 建一个
        cmp = document.createElement('s');
        cmp.className = 'amada-qv__price-was';
        cmp.setAttribute('data-amada-qv-compare', '');
        cmp.setAttribute('data-amada-filled', '');
        cmp.textContent = orig;
        box.appendChild(cmp);
      }
      box.classList.add(CLS);
    } finally {
      writing = false;
    }
  }

  /** 折扣没了或变体不适用 → 把价格还原成主题原值，别留着上一件的折后价 */
  function restore(box, preserveCurrent) {
    var now = nowEl(box);
    if (now) {
      var orig = now.getAttribute('data-amada-orig-price');
      writing = true;
      try {
        if (!preserveCurrent && orig && now.getAttribute('data-amada-shown') === now.textContent.trim()) {
          now.textContent = orig;
        }
        now.removeAttribute('data-amada-orig-price');
        now.removeAttribute('data-amada-shown');
        now.removeAttribute('data-amada-price-variant');
        var cmp = compareEl(box);
        if (cmp && cmp.hasAttribute('data-amada-filled')) {
          if (preserveCurrent) {
            // 变体事件后价格/compare 由主题或 QV 写入，保留其当前值，只摘掉我们的所有权标记。
            cmp.removeAttribute('data-amada-filled');
          } else if (cmp.matches && cmp.matches('[data-amada-qv-compare]') && cmp.parentNode) {
            cmp.parentNode.removeChild(cmp);
          } else {
            cmp.textContent = '';
            cmp.removeAttribute('data-amada-filled');
          }
        }
      } finally {
        writing = false;
      }
    }
    box.classList.remove(CLS);
  }

  /**
   * 两条链都在更新价格后派发，只标记对应作用域、下一轮统一处理。
   * 真实 variant ID 改变时识别“新原价恰好等于旧折后价”的缓存碰撞。
   */
  function reset(event) {
    var detail = event && event.detail;
    var scope = detail && detail.amadaScope === 'qv' ? 'qv' : 'pdp';
    variantRefreshPending[scope] = true;
    schedule();
  }

  function run() {
    if (writing) return;

    // ① quick view 抽屉（分类页/搜索页）
    var qv = document.querySelector('[data-amada-drawer="amada-quickview"]');
    if (qv) {
      var qvCoupon = qv.querySelector('.amada-coupon--qv[data-amada-coupon]');
      var qvVariantId = currentVariantId(qvCoupon);
      var qvEligible = variantIsEligible(qvCoupon, qvVariantId);
      var qvRule = qvEligible ? readRule(qvCoupon) : null;
      if (qvCoupon) qvCoupon.hidden = !qvEligible;
      var qvBoxes = qv.querySelectorAll('.amada-qv__price');
      for (var i = 0; i < qvBoxes.length; i++) {
        if (qvRule) paint(qvBoxes[i], qvRule, variantRefreshPending.qv, qvVariantId);
        else restore(qvBoxes[i], variantRefreshPending.qv);
      }
    }
    variantRefreshPending.qv = false;

    // ② 商品详情页主价格 + 吸底条
    if (!document.body || document.body.className.indexOf('template-product') < 0) {
      variantRefreshPending.pdp = false;
      return;
    }
    var coupon = document.querySelector('.amada-coupon--pdp[data-amada-coupon]');
    var pdpVariantId = currentVariantId(coupon);
    var eligible = variantIsEligible(coupon, pdpVariantId);
    var rule = eligible ? readRule(coupon) : null;
    if (coupon) coupon.hidden = !eligible;
    var boxes = document.querySelectorAll(
      '.product__primary-right .product__price, .product__price-block .product__price, .sticky-atc-bar__price'
    );
    for (var j = 0; j < boxes.length; j++) {
      if (rule) paint(boxes[j], rule, variantRefreshPending.pdp, pdpVariantId);
      else restore(boxes[j], variantRefreshPending.pdp);
    }
    variantRefreshPending.pdp = false;
  }

  var pending = null;
  function schedule() {
    if (writing) return;
    if (pending) return;
    pending = window.setTimeout(function () {
      pending = null;
      run();
    }, 0);
  }

  function boot() {
    run();
    /* 变体切换：主题的公开事件（assets/custom-events.js）。两个名字都听，
       不同渲染路径派发的不一样。 */
    document.addEventListener('variant:change', reset);
    document.addEventListener('product:variant-change', reset);
    /* 主题/quick view 也可能不派事件、直接重写文本 → 兜一层 MutationObserver。
       券码/金额/比例/资格是 data 属性，必须显式观察 attributes；attributeFilter 只列
       输入属性，排除本脚本的缓存与显隐属性，避免 paint/restore 自己反复唤醒观察器。 */
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: RULE_ATTRIBUTES,
      });
    }
  }

  // Node 的业务规则测试直接复用生产函数；浏览器里不暴露全局。
  if (typeof module === 'object' && module.exports) {
    module.exports = {
      discountText: discountText,
      readRule: readRule,
      variantIsEligible: variantIsEligible,
      formatLike: formatLike,
      paint: paint,
      restore: restore,
      currentVariantId: currentVariantId,
      ruleAttributes: RULE_ATTRIBUTES.slice(),
    };
    return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
